exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tagMain[data-v-12d22ed6]{display:-webkit-box;display:-ms-flexbox;display:flex;max-height:58vh;overflow:hidden}.tagMain .left[data-v-12d22ed6]{padding-right:10px;width:70%}.tagMain .left .tagTypeBox[data-v-12d22ed6]{margin-bottom:10px;line-height:2;border-bottom:1px solid #e6ebf5}.tagMain .left .allTagBox[data-v-12d22ed6]{height:460px;overflow-y:scroll}.tagMain .right[data-v-12d22ed6]{width:30%;overflow-y:scroll}.tagMain[data-v-12d22ed6]  .el-tag{margin-right:5px;margin-bottom:5px;cursor:pointer}", ""]);

// exports
